import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { query, where, getDocs, collection } from "firebase/firestore";
//import { db } from "../firebase";  
import Cookies from 'js-cookie';
//page links   
import './footer.css';
import GooglePlayIcon from '../assets/android-app_v1.png';
import Appstore from '../assets/ios-app_v1.png';
import { BsYoutube } from 'react-icons/bs';
export default function Footers() {
  const navigate = useNavigate();
  const location = useLocation();
  const [Jobtasks, setJobtasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [rowCounts, setRowCounts] = useState({
    users: 0,
    postdata: 0,
    companys: 0,
    total: 0
  });




  return (
    <div className="footer-body ">

      <div className="container_size">
        <div className='post-container'>
          <div className='post_div'>
            <div className='ui-grid'>
              <div className='ui-items'>
                <table  >
                  <tr>
                    <td>
                      <div className="logo-name"><b>Viabig</b>.com</div>
                    </td>
                  </tr>
                  {Cookies?.get("State") && (
                    <tr>
                      <td>
                        <div className="country-name">
                          {Cookies.get("State") + " / " + Cookies.get("Country")}
                        </div>
                      </td>
                    </tr>
                  )}

                  <tr>
                    <td>
                      <a className="tab-link" onClick={() => navigate('/support')}>Help & Support</a>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a className="tab-link" title='About' href='/about'>About Us</a>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <div className="social-icons">
                        {/* <BsInstagram title='Follow on Instagram' onClick={() => window.open('https://www.instagram.com/kangdesk', '_blank')} /> */}

                        {/* <BsFacebook onClick={() => window.open('https://www.facebook.com/editortask', '_blank')} /> */}
                        {/* <BsYoutube title='Subscribe on YouTube' onClick={() => window.open('https://www.youtube.com/@kangdesk?sub_confirmation=1', '_blank')} /> */}
                        {/* <BsLinkedin />
      <BsX /> */}
                      </div>
                    </td>
                  </tr>
                </table>
                <table >

                  <tr>
                    <td>
                      <a className="tab-link" title='App dwonload' href='/install-app'>Directly on our app.</a>
                    </td>
                  </tr>
                  <tr>
                    <td onClick={() => navigate('/install-app')}>
                      <img alt='Editortask Android app' title='Android app' src={GooglePlayIcon} className="app-img" />
                    </td>
                  </tr>
                  <tr>
                    <td onClick={() => navigate('/install-app')}>
                      <img alt="Editortask iOS app" title='iOS app' src={Appstore} className="app-img" />
                    </td>
                  </tr>
                </table>
              </div>

              <div className='ui-items'>
                <table >
                  <tr>
                    <td>
                      <div className="tab-title" >Products</div>
                    </td>
                  </tr>
                  <tr><td><a className="tab-link" title='Services' href='/services'>Services</a></td></tr>
                         <tr><td><a className="tab-link" title='Phonebook' href='/phonebook'>Phonebook</a></td></tr>
                   <tr><td><a className="tab-link" title='Community' href='/community'>Community</a></td></tr>
        
                  <tr><td><a className="tab-link" href='/software'>Software</a></td></tr>
                  <tr><td><a className="tab-link" href='https://callqr.com'>CallQR</a></td></tr>

                </table>
              </div>
              <div className='ui-items'>
                <table >
                  <tr>
                    <td>
                      <div className="tab-title">Quick links</div>
                    </td>
                  </tr>
                  <tr>
                    <td><a className="tab-link" title='Image to pdf' href='/image-to-pdf'>Image to pdf</a></td>
                  </tr>
                  <tr>
                    <td><a className="tab-link" title='Favicon Generato' href='/favicon-generator'>Favicon Generator</a></td>
                  </tr>
                  <tr>
                    <td>
                      <a className="tab-link" title='word counter' href='/word-counter'>Word counter</a>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a className="tab-link" title='Typing master' href='/typing-master'>Typing master</a>
                    </td>
                  </tr>
                  <tr>
                    <td>

                    </td>
                  </tr>



                </table>
              </div>
              <div className='post_updates'>
                <div className='border p-1 items-back rounded'>
                  <table   >
                    <tr>
                      <td>
                        <div className="tab-title">Contact Us</div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                     
                          <a className="tab-link bold" href='https://wa.me/919530621728?text=Hello%20I%20am%20interested' title='Partners'  >Support : <b className='fw-bold text-h1'>+91-9530621728</b> <a className='green bold' >Whatsapp</a></a>
                      </td>
                    </tr>
                    <br/>
                    <tr>
                      <td>
                        <table>
                          <tr>
                            <td>
                              <input
                                className="text-h2 p-2 border w-full"
                                                               
                                maxLength={10}                                
                                placeholder="88728XXXXX"
                                onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                              />
                            </td>
                            <td><div className='button-ui p-2'>Call Me</div></td>
                          </tr>
                        </table>
                      </td>
                    </tr>

                  </table>
                </div>
              </div>
            </div>

          </div>

        </div>





      </div>
      <div className="tearms_body">
        <div className="container_size">
          <div className='post-container'>
            <div className='post_div'>
              <div className='ui-grid'>
                <div className='ui-items'>&#169; <b>Viabig.com</b> - {new Date().getFullYear()} All rights reserved</div>
                <div className='ui-items'><a className="tab-link" title='Terms and Conditions' href='/terms-and-conditions'>Terms and Conditions</a></div>
              </div>


            </div>
            <div className="post_updates">
              <div>
                <a className="tab-link" href="https://kang.in" _target ><b>Kang Technology</b></a> <b>Update:01/08/2025</b>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
